import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MailService } from 'src/app/service/mail/mail.service';
import { environmentCommon } from 'src/environments/environment-common';
import { CONTACT_US_FEATURES, SIZE_OPTIONS, } from '../../../data/contact-us/contact-us.data';
import { COUNTRIES } from '../../../data/country/country.data';
import { STATES_AND_UTS } from '../../../data/state/states.data';
import { URLS } from '../../../data/navigation/navigation.data';
import { ToastService } from '../../../service/toast/toast.service';
import { Title } from '@angular/platform-browser';
import { Meta } from '@angular/platform-browser';
import { NAVIGATIONS } from '../../../data/navigation/navigation.data';

@Component({
  selector: 'app-contact-us-page',
  templateUrl: './contact-us-page.component.html',
  styleUrls: ['./contact-us-page.component.scss'],
})
export class ContactUsPageComponent implements OnInit {
  form: FormGroup;
  submitted = false;
  URLS = URLS;
  environmentCommon = environmentCommon;
  emailSent = false;

  features = CONTACT_US_FEATURES;
  countries = COUNTRIES;
  states = STATES_AND_UTS;
  sizeOptions = SIZE_OPTIONS;

  //loading = false;

  appHeroContent = [
    { text: $localize`:@@contactUs.appHero:Contact Us`, level: 1 }
  ];

  constructor(
    private formBuilder: FormBuilder,
    private toastService: ToastService,
    private mailService: MailService,
    private titleService: Title,
    private metaService: Meta

  ) {
    // this.loadingService.sharedLoading.subscribe(
    //   (loading) => (this.loading = loading)
    // );
  }

  ngOnInit(): void {
    this.setTitleAndMeta();
    
    this.form = this.formBuilder.group({
      firstName: ['', Validators.required],
      secondName: ['', Validators.required],
      workEmail: [
        '',
        Validators.compose([Validators.required, Validators.email]),
      ],
      workPhone: [
        '',
        Validators.pattern(/^\d{10}$/)  // 10 digits
      ],
      // companyWebsite: ['', Validators.maxLength(50)],
      // companySize: ['', Validators.required],
      // country: ['', Validators.required],
      state: ['', Validators.required],
      anythingElse: ['', Validators.maxLength(500)],
    });

  }

  onSubmit() {
    // if (this.loading) {
    //   return;
    // }

    this.submitted = true;

    const errorMessages = {
      firstName: $localize`:@@contactUs.error.firstName:Please provide a first name`,
      secondName: $localize`:@@contactUs.error.secondName:Please provide a second name`,
      workEmail: $localize`:@@contactUs.error.workEmail:Please provide a valid email`,
      workPhone: $localize`:@@contactUs.error.workPhone:Please provide a valid phone number`,
      companySize: $localize`:@@contactUs.error.companySize:Please provide a company size`,
      // country: ':@@contactUs.error.country:Please provide a country',
      state: $localize`:@@contactUs.error.state:Please provide a state`,
    };

    if (this.form.invalid) {
      for (const control in this.form.controls) {
        if (this.form.controls[control].invalid) {
          this.toastService.error(errorMessages[control], '');
        }
      }
    }

    if (this.form.valid) {
      this.mailService
        .sendContactUsMail({
          firstName: this.form.controls.firstName.value,
          lastName: this.form.controls.secondName.value,
          email: this.form.controls.workEmail.value,
          phone: this.form.controls.workPhone.value,
          // country: this.form.controls.country.value,
          state: this.form.controls.state.value,
          message: this.form.controls.anythingElse.value,
        })
        .subscribe({
          next: (data) => {
            this.toastService.success("Enquiry submitted successfully!", '');
          },
          error: (error) => {
            if (error.status === 500) {
              this.toastService.error("Internal server error. Please try again later.", '');
            } else {
              this.toastService.error("An error occurred while submitting the enquiry.", '');
            }
          },
          complete: () => {
            console.log("Request complete");
          }
        });
    }
  }

  // changeCountry(event: any) {
  //   this.form.controls.country.setValue(event.target.value, {
  //     onlySelf: true,
  //   });
  // }

  changeState(event: any) {
    this.form.controls.state.setValue(event.target.value, {
      onlySelf: true,
    });
  }

  changeCompanySize(event: any) {
    this.form.controls.companySize.setValue(event.target.value, {
      onlySelf: true,
    });
  }

  setTitleAndMeta() {

    this.titleService.setTitle(NAVIGATIONS.contactUs.title);

    this.metaService.updateTag({ name: 'description', content: NAVIGATIONS.contactUs.meta });
  }
}
